import { render, staticRenderFns } from "./Recreate.vue?vue&type=template&id=26310f0a&lang=pug"
import script from "./Recreate.vue?vue&type=script&lang=js"
export * from "./Recreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports